<div class="min-height" fxLayout fxLayoutAlign="center center">
  <article>
    <h1>Work in progress</h1>
  </article>
</div>
